import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState,
    fetchSingleRecord,
    payAllAtOnceSuccess,
    payAllAtOnce,
    payAllAtOnceFail,
} from './dossier.action';
import { Dossier } from './dossier.model';

export interface DossierRecordsState {
    singleData: Dossier;
    loading: boolean;
    error: any;
}

export const initialState: DossierRecordsState = {
    singleData: null,
    loading: false,
    error: null,
};


export const dossierRecordReducer = createReducer(

    initialState,

    // FETCH SINGLE RECORD
    on(fetchSingleRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null, loading: false };
    }),

    // PAY ALL AT ONCE RECORD
    on(payAllAtOnce, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(payAllAtOnceSuccess, (state) => {
        return { ...state, error: null, loading: false };
    }),
    on(payAllAtOnceFail, (state, error) => {
        return { ...state, error: error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);